export const EmailPattern =
  // eslint-disable-next-line no-useless-escape
  /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
